"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/modules/auth/stores/useAuthStore";
import { useAuthModal } from "@/modules/auth/stores/useAuthModal";

/**
 * Reidrata a sessão a partir do cookie de identidade (auth_user), SEM rede: o
 * access token é httpOnly e o proxy o valida/renova na primeira chamada.
 */
export function AuthInit() {
    const hydrate = useAuthStore((state) => state.hydrate);
    const openModal = useAuthModal((state) => state.openModal);

    useEffect(() => {
        hydrate();

        const params = new URLSearchParams(window.location.search);
        if (params.get("auth") === "login") openModal("login");
    }, [hydrate, openModal]);

    return null;
}
